export const MEMBERS = `
  query members(
    $tenant_id: Int!
    $skip: Int
    $take: Int
    $orderBy: MemberOrderInput
    $filter: MemberFilterInput
    $searchText: String
  ) {
    members(
      tenant_id: $tenant_id
      skip: $skip
      take: $take
      orderBy: $orderBy
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on Member {
        id
        contact_id
        contact {
          id
          firstname
          lastname
          email
          phone
          mobile
          birth_date
          identification
          identification_type_id
          gender
          country
          city
          province
          address
          zip_code
          timezone
          position
          secondary_email
          zoho_id
          company_id
          humand_user_id
          humand_sync_status
          its
          uts
          bank_account
          bank_account_number
          bank_account_owner
          bank_account_cbu
          company {
            id
            name
            fantasy_name
            cuit
            phone
            website
            state
            industry
            income
            employees
            province_id
            city
            zoho_id
            active
            vistage20_id
            its
            uts
            dts
            income_company_incomeToincome {
              id
              name
            }
            company_industry {
              id
              name
            }
          }
          contact_contact_status {
            id
            status_id
            end_date
            status {
              id
              name
              hex_color
            }
          }
        }
        group_member {
          id
          group_id
          group {
            id
            name
            program {
              id
              name
            }
          }
        }
        program {
          id
          name
        }
        program_variant {
          id
          name
        }
        program_pricing {
          id
          monthly_fee
          signup
        }
        entry_form {
          id
          pdf
          entry_form_benefit {
            id
            benefit_id
            benefit {
              id
              name
            }
          }
        }
        start_date
        end_date
        monthly_fee
        signup_fee
        monthly_fee_discount
        signup_discount
        is_reentry
        bill_type
        payment_type
        installment_payment
        special_payment_method
        comments
        entry_form_id
        custom_monthly_fee
        custom_signup
        license_count_last_12_months
        card_type
        card_number
        card_due_date
        its
        uts
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const CHECK_MEMBER_CONTACT = `
  query checkMemberContact(
    $input: MemberContactValidationInput!
    $tenant_id: Int!
  ) {
    checkMemberContact(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on MemberContactValidation {
        emailStatus
        identificationStatus
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const SEARCH_MEMBER_CONTACTS = `
  query searchMemberContacts(
    $input: MemberContactSearchInput!
    $tenant_id: Int!
  ) {
    searchMemberContacts(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on MemberContactSearchResult {
        contactId
        fullName
        status
        chairName
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const MEMBERS_COUNT = `
  query membersCount(
    $tenant_id: Int!
    $orderBy: MemberOrderInput
    $filter: MemberFilterInput
    $searchText: String
  ) {
    membersCount(
      tenant_id: $tenant_id
      orderBy: $orderBy
      filter: $filter
      searchText: $searchText
    ) {
      __typename
      ... on Count {
        count
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
